import React from 'react';
import { IVehicle } from './types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import Link from 'components/Link';
import { getVehiclePriceEstimateModalUrl } from 'lib/utils/store/vehicle';

export function NoEstimate ({ vehicle }: { vehicle: IVehicle }) {
    const { t } = useTranslation('vehicles');
    const location = useLocation();
    const { id } = vehicle;

    return (
        <div className="vehicle-price-estimate-display__no-estimate">
            <Link
                to={getVehiclePriceEstimateModalUrl(location, id)}
                trackName="showPricePredictionForm"
                className="button button--centered detail-section__cta"
                type="button"
            >
                {t('vehicles:pricePrediction.cta.showPriceEstimate')}
            </Link>
            <span>{t('vehicles:pricePrediction.infoText.priceEstimate')}</span>
        </div>
    );
}
